export enum Feature {
    MatchMarketsFavorites = 'match.markets-favorites',
    CategorizerTopTournaments = 'categorizer.hoist-top-tournaments',
    CategorizerSortingApi = 'categorizer.sorting-api',
    MatchListSportEventRowOverview = 'match-list.sport-event-row-overview',
    BetslipStakeSuggesterByCurrency = 'betslip.stake-suggester-by-currency',
    BetslipRememberLastBetSum = 'betslip.remember-last-bet-sum',
    BetslipRefillBalanceModal = 'betslip.refill-balance-modal',
    WidgetHideTopMatches = 'widget.hide-top-matches',
    BannerButtonBackground = 'banner.button-background-new',
    AppUpdateColors = 'app.update-colors',
    StreamGridPlayer = 'stream.grid-player',
    MatchStatisticButton = 'match.statistic-button',
}

export enum MultivariateFeature {
    HelperBackgroundColor = 'helper.background-color',
}
